import { useState } from 'react';
import ExploreContentWrapper from 'components/pages/explore/explorecontentwrapper/ExploreContentWrapper';
import ExploreSearchSidebar from 'components/pages/explore/exploresearchsidebar/ExploreSearchSidebar';
import ExploreDataWrapper from 'components/pages/explore/exploredatawrapper/ExploreDataWrapper';
import ExploreMobileSortFilter from 'components/pages/explore/exploremobilesortfilter/ExploreMobileSortFilter';
import ExploreSearchResultTitle from 'components/pages/explore/exploresearchwrapper/exploresearchresulttitle/ExploreSearchResultTitle';
import ExploreFilter from 'components/pages/explore/explorewrappernew/explorefilter/ExploreFilter';
import ExploreDataWrapperNew from 'components/pages/explore/explorewrappernew/exploredatawrappernew/ExploreDataWrapperNew';

import classes from './ExploreSearchWrapperNew.module.scss';

const ExploreSearchWrapperNew = ({
	filters,
	searchData: {
		searchKeyword,
		selectedCategories,
		selectedContent,
		selectedOrdering,
		selectedCareerPath,
		selectedPrice,
		selectedStatus,
		selectedProficiency,
		selectedPage,
		selectedHighlighted,
	},
	handleCategoryClick,
	handlePriceClick,
	handlePriceSelect,
	handleProficiencyClick,
	handleProficiencySelect,
	handleStatusSelect,
	handleQueryKeywordChange,
	handleContentTypeSelect,
	handleOrderingChange,
	handleCareerPathChange,
	handlePageChange,
	handleHighlightedChange,
}) => {	

	return (
		<div
			className={`${classes['explore-search-wrapper']} d-flex flex-column gap-3 my-3 my-lg-5 align-items-center`}>

			{/* <div className="w-100 d-block d-lg-none">
				<ExploreMobileSortFilter
					filters={filters}
					searchKeyword={searchKeyword}
					selectedCategories={selectedCategories}
					selectedPrice={selectedPrice}					
					selectedProficiency={selectedProficiency}
					selectedCareerPath={selectedCareerPath}
					handleCategoryClick={handleCategoryClick}
					handlePriceClick={handlePriceClick}
					handleProficiencyClick={handleProficiencyClick}
					handleQueryKeywordChange={handleQueryKeywordChange}
					selectedContent={selectedContent}
					handleContentTypeSelect={handleContentTypeSelect}
					selectedOrdering={selectedOrdering}
					handleOrderingChange={handleOrderingChange}
					selectedHighlighted={selectedHighlighted}
					handleHighlightedChange={handleHighlightedChange}
					handleCareerPathChange={handleCareerPathChange}
				/>
			</div> */}
			<div className="container row gap-4">
				<div className="col-12">
					<h3>Recent Courses</h3>
					<p>Learn all you need to begin a new career as a professional.</p>
					<ExploreFilter
						filters={filters}
						searchKeyword={searchKeyword}
						selectedCategories={selectedCategories}
						selectedPrice={selectedPrice}
						selectedStatus={selectedStatus}
						selectedProficiency={selectedProficiency}
						selectedHighlighted={selectedHighlighted}
						selectedCareerPath={selectedCareerPath}
						handleCategoryClick={handleCategoryClick}
						handlePriceClick={handlePriceClick}
						handlePriceSelect={handlePriceSelect}
						handleProficiencySelect={handleProficiencySelect}
						handleStatusSelect={handleStatusSelect}
						handleQueryKeywordChange={handleQueryKeywordChange}
						handleHighlightedChange={handleHighlightedChange}
						handleCareerPathChange={handleCareerPathChange}
					/>
					<ExploreDataWrapperNew
						handlePageChange={handlePageChange}
						selectedPage={selectedPage}
					/>
				</div>
			</div>
		</div>
	);
};

export default ExploreSearchWrapperNew;
